export const getRouteParam = param => {
  return (state, props) => props.match.params[param];
};
